import { combineEpics } from "redux-observable";
import { epicGameTrackingClientFunnelAppConnected } from "./epics/epicGameTrackingClientFunnelAppConnected";
import { epicGameTrackingClientFunnelAppStart } from "./epics/epicGameTrackingClientFunnelAppStart";
import { epicGameTrackingClientFunnelConnectEnd } from "./epics/epicGameTrackingClientFunnelConnectEnd";
import { epicGameTrackingClientFunnelPlayerBaseShow } from "./epics/epicGameTrackingClientFunnelPlayerBaseShow";
import { epicGameTrackingClientFunnelPlayTime } from "./epics/epicGameTrackingClientFunnelPlayTime";
import { epicGameTrackingClientFunnelTutorial } from "./epics/epicGameTrackingClientFunnelTutorial";
import { epicGameTrackingClientFunnelTutorialStart } from "./epics/epicGameTrackingClientFunnelTutorialStart";
export var epicGameTrackingClientFunnel = combineEpics(epicGameTrackingClientFunnelAppStart, epicGameTrackingClientFunnelPlayTime, epicGameTrackingClientFunnelConnectEnd, epicGameTrackingClientFunnelPlayerBaseShow, epicGameTrackingClientFunnelTutorial, epicGameTrackingClientFunnelAppConnected, epicGameTrackingClientFunnelTutorialStart);



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epicGameTrackingClientFunnel.ts
// module id = 1867
// module chunks = 3